<template>
  <div class="large-pay">
    <van-nav-bar title="大额拨付" left-arrow @click-left="goBack" />

    <div class="pay-box">
      <div class="pay-icon">
        <img src="@/assets/images/img/ic_fd.png">
      </div>

      <div class="pay-title">开通大额拨付功能</div>

      <div class="pay-desc">
        开通大额拨付功能，需支付
        <span>598</span>
        元
      </div>

      <div class="pay-notice">
        注：为保障资金安全下发，需开通大额拨付功能！本次收款仅用于大额通道的技术联调与系统测试。
      </div>

      <div v-if="opened" class="opened">
        大额拨付功能已开通
      </div>

      <van-button
        v-else
        type="primary"
        block
        round
        :loading="loading"
        :disabled="loading"
        @click="openPasswordDialog"
      >
        开通大额拨付
      </van-button>
    </div>

    <van-dialog
      v-model="passwordVisible"
      title="支付密码"
      show-cancel-button
      :before-close="beforePasswordClose"
    >
      <div class="password-box">
        <div class="password-tip">请输入支付密码</div>
        <van-field
          v-model="payPassword"
          type="password"
          maxlength="6"
          placeholder="请输入支付密码"
          clearable
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import request from "@utils/request";

export default {
  name: "LargePay",

  data() {
    return {
      loading: false,
      opened: false,
      passwordVisible: false,
      payPassword: ""
    };
  },

  created() {
    this.getStatus();
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    async getStatus() {
      try {
        const res = await request.get("/api/v1/user/largePayStatus");
        console.log("大额拨付状态返回：",res);

        const data = this.parseResponse(res);

        if (data.code === 200) {
          this.opened=Number(
            data.data&&data.data.large_pay_status
          )===1;
        }
      } catch(e) {
        console.log(e);
      }
    },

    openPasswordDialog() {
      if(this.loading||this.opened) {
        return;
      }

      this.payPassword="";
      this.passwordVisible=true;
    },

    async beforePasswordClose(action,done){
  if(action==="cancel"){
    this.payPassword="";
    done();
    return;
  }

  if(this.loading){
    done(false);
    return;
  }

  if(!this.payPassword){
    this.$toast("请输入支付密码");
    done(false);
    return;
  }

  if(this.payPassword.length<6){
    this.$toast("请输入6位支付密码");
    done(false);
    return;
  }

  this.loading=true;

  try{
    const res=await request.post("/api/v1/user/largePayOpen",{
      pwd:this.payPassword
    });

    console.log("大额拨付开通返回：",res);

    const data=this.parseResponse(res);

    if(data.code!==200){
      this.loading=false;
      this.$toast(data.msg||"开通失败");
      done(false);
      return;
    }

    this.loading=false;
    this.opened=true;
    this.payPassword="";
    done();

    this.$dialog.success(
      data.msg||"大额拨付功能开通成功"
    ).then(()=>{
      this.$router.go(-1);
    });

  }catch(e){
    this.loading=false;

    console.log("大额拨付开通异常：",e);

    let data=null;

    if(e&&e.response&&e.response.data){
      data=this.parseResponse(e.response.data);
    }else if(e&&e.data){
      data=this.parseResponse(e.data);
    }else{
      data=this.parseResponse(e);
    }

    this.$toast(
      (data&&data.msg)||"开通失败，请稍后重试"
    );

    done(false);
  }
},

    parseResponse(res) {
      if(!res) {
        return {};
      }

      if(typeof res==="object") {
        if(res.data&&typeof res.data==="object") {
          if(
            typeof res.data.code!=="undefined"||
            typeof res.data.msg!=="undefined"
          ) {
            return res.data;
          }
        }

        return res;
      }

      if(typeof res==="string") {
        try {
          return JSON.parse(res);
        } catch(e) {
          return {
            code:500,
            msg:res
          };
        }
      }

      return {};
    }
  }
};
</script>

<style scoped>
.large-pay{
  min-height:100vh;
  background:#f5f5f5;
}
.pay-box{
  margin:30px 20px;
  padding:35px 25px;
  background:#fff;
  border-radius:12px;
  text-align:center;
}
.pay-icon img{
  width:80px;
  height:80px;
}
.pay-title{
  margin-top:20px;
  font-size:22px;
  font-weight:bold;
}
.pay-desc{
  margin:20px 0 18px;
  color:#666;
  font-size:16px;
}
.pay-desc span{
  color:#f44336;
  font-size:26px;
  font-weight:bold;
}
.pay-notice{
  margin:0 0 30px;
  padding:12px 14px;
  background:#fff7e8;
  border:1px solid #ffe0a3;
  border-radius:8px;
  color:#9a6700;
  font-size:13px;
  line-height:1.7;
  text-align:left;
}
.opened{
  color:#4caf50;
  font-size:18px;
  font-weight:bold;
}
.password-box{
  padding:10px 15px 20px;
}
.password-tip{
  margin-bottom:10px;
  color:#666;
  font-size:14px;
}
</style>